import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

// STYLE
import './TextContainer.sass'

import { Typography } from 'components';

const TextContainer = ({ text, length }) => {
  const [open, handleOpen] = useState(false);

  // RENDER TEXT BY OPEN VALUE AND TEXT LENGTH
  function renderTextContent () {
    return !open ? `${text.slice(0, length-3)}...` : text
  }

  // SET BUTTON TEXT AND ACTION TYPE BY OPEN VALUE
  function handleBottomButtonType () {
    return !open
      ? <div onClick={() => handleOpen(true)} ><Typography type="paragraph-medium" className="TextContainer__button">Continuar lendo</Typography></div>
      : <div onClick={() => handleOpen(false)} ><Typography type="paragraph-medium" className="TextContainer__button">Mostrar menos</Typography></div>
  }

  // RENDER OR NOT THE BOTTOM BUTTON
  function renderBottomButton () {
    return text.length <= length
      ? null
      : handleBottomButtonType()
  }

  useEffect(() =>{
    if (text && text.length <= length) handleOpen(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="TextContainer">
      <pre className={classNames('TextContainer__text', {'TextContainer__text--open': open})}>
        {text 
          ? renderTextContent() 
          : <span className="TextContainer__text TextContainer__text--empty">Sem informações</span> 
        }
      </pre>
      {text 
        ? renderBottomButton() 
        : null 
      }
    </div>
  )
}

export {
  TextContainer
}